import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 30,
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "22pt",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
    paddingBottom: 10,
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "12pt",
    lineHeight: "18pt",
    padding: "10px 0",
  },
  ICON: {
    fontSize: "36pt",
    textAlign: "center",
    color: "#999",
    display: "inline-block",
  },
};
